import dayjs from "dayjs";
import { UserTypes } from "@/configs/AppConfig";

const keys = {
    userType: 'userType',
    authType: 'authType',
    user: 'user',
    appUserKey: 'aukey',
    systemUserKey: 'sukey',
    rights: 'userRights',
    sessionExpiryTs: 'sessionExpiryTs',
    lastRightsReload: 'lastRightsReload'
}

class UserSessionService {
    getUserType() {
        return window.localStorage.getItem(keys.userType);
    }
    getAuthType() {
        return window.localStorage.getItem(keys.authType);
    }

    getUser() {
        return JSON.parse(window.localStorage.getItem(keys.user));
    }

    getUserKeyObj() {
        const userType = this.getUserType()
        if (userType === UserTypes.SYSTEM_USER) {
            return { [keys.systemUserKey]: window.localStorage.getItem(keys.systemUserKey) }
        }
        else if (userType === UserTypes.APP_USER) {
            return { [keys.appUserKey]: window.localStorage.getItem(keys.appUserKey) }
        }
        return null
    }

    getRights() {
        return JSON.parse(window.localStorage.getItem(keys.rights));
    }


    getSessionExpiryTimestamp() {
        return window.localStorage.getItem(keys.sessionExpiryTs);
    }

    setSession(userType, user, userKey, rights) {
        window.localStorage.setItem(keys.user, JSON.stringify(user));
        window.localStorage.setItem(keys.userType, userType);
        window.localStorage.setItem(userType == UserTypes.SYSTEM_USER ? keys.systemUserKey : keys.appUserKey, userKey);
        this.setRights(rights)
        this.extendSessionExpiryTimestamp()
        window.localStorage.removeItem(keys.authType);
    }

    setAuthType(userType) {
        window.localStorage.setItem(keys.authType, userType);
    }

    setLastRightsReloadTimestamp(timeStamp = dayjs().unix()) {
        window.localStorage.setItem(keys.lastRightsReload, timeStamp + '');
    }

    setRights(rights) {
        window.localStorage.setItem(keys.rights, JSON.stringify(rights));
        this.setLastRightsReloadTimestamp()
    }

    removeSession() {
        window.localStorage.setItem(keys.userType, UserTypes.GUEST);
        window.localStorage.removeItem(keys.user);
        window.localStorage.removeItem(keys.rights);
        window.localStorage.removeItem(keys.systemUserKey);
        window.localStorage.removeItem(keys.appUserKey);
        window.localStorage.removeItem(keys.lastRightsReload);
        window.localStorage.removeItem(keys.sessionExpiryTs);
        window.localStorage.removeItem(keys.authType);
    }

    extendSessionExpiryTimestamp() {
        const timeStamp = dayjs().add(1, 'hours').unix();
        window.localStorage.setItem(keys.sessionExpiryTs, timeStamp + '');
    }


    isSessionExpired() {
        const sessionExpiryTs = this.getSessionExpiryTimestamp();
        if (sessionExpiryTs) {
            const currTs = dayjs().unix();
            if (sessionExpiryTs <= currTs) {
                this.removeSession();
                return true
            }
            else {
                this.extendSessionExpiryTimestamp();
                return false
            }
        }
        this.removeSession();
        return true;
    }
}
export default new UserSessionService()